/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface AdminRiskSummaryDto
 */
export interface AdminRiskSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminRiskSummaryDto
     */
    date: Date;
    /**
     * 
     * @type {GenericColors}
     * @memberof AdminRiskSummaryDto
     */
    statusColor: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    statusLabel: string;
    /**
     * 
     * @type {IdLabel}
     * @memberof AdminRiskSummaryDto
     */
    simulationIdentifier: IdLabel;
    /**
     * 
     * @type {IdLabel}
     * @memberof AdminRiskSummaryDto
     */
    contractIdentifier?: IdLabel;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof AdminRiskSummaryDto
     */
    quoteIdentifiers?: Array<IdLabel>;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof AdminRiskSummaryDto
     */
    insureds?: Array<IdLabel>;
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    branchCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminRiskSummaryDto
     */
    products: Array<string>;
    /**
     * Provenance de la simulation — id pour matcher la facette simulationSource
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    sourceId?: string | null;
    /**
     * Code de provenance : ESPACE_PRO | ESPACE_MEMBRE (logique/badge)
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    sourceCode?: string | null;
    /**
     * Libellé affichable de la provenance (ex. « Espace pro »)
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    sourceLabel?: string | null;
    /**
     * Number of unread notifications for this simulation
     * @type {number}
     * @memberof AdminRiskSummaryDto
     */
    unreadNotificationCount?: number;
    /**
     * Dossiers EMPRUNTEUR (EMP) uniquement : id du projet d'emprunt (au niveau racine, comme la liste devis). Sert aux routes emprunteur — ne plus déduire le projet d'un autre champ.
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    borrowerProjectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    brokerName: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    plateformeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRiskSummaryDto
     */
    plateformeName?: string | null;
}



/**
 * Check if a given object implements the AdminRiskSummaryDto interface.
 */
export function instanceOfAdminRiskSummaryDto(value: object): value is AdminRiskSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('simulationIdentifier' in value) || value['simulationIdentifier'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('brokerName' in value) || value['brokerName'] === undefined) return false;
    return true;
}

export function AdminRiskSummaryDtoFromJSON(json: any): AdminRiskSummaryDto {
    return AdminRiskSummaryDtoFromJSONTyped(json, false);
}

export function AdminRiskSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRiskSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'statusColor': GenericColorsFromJSON(json['statusColor']),
        'statusLabel': json['statusLabel'],
        'simulationIdentifier': IdLabelFromJSON(json['simulationIdentifier']),
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : IdLabelFromJSON(json['contractIdentifier']),
        'quoteIdentifiers': json['quoteIdentifiers'] == null ? undefined : ((json['quoteIdentifiers'] as Array<any>).map(IdLabelFromJSON)),
        'insureds': json['insureds'] == null ? undefined : ((json['insureds'] as Array<any>).map(IdLabelFromJSON)),
        'branchCode': json['branchCode'],
        'products': json['products'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'sourceCode': json['sourceCode'] == null ? undefined : json['sourceCode'],
        'sourceLabel': json['sourceLabel'] == null ? undefined : json['sourceLabel'],
        'unreadNotificationCount': json['unreadNotificationCount'] == null ? undefined : json['unreadNotificationCount'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'brokerId': json['brokerId'],
        'brokerName': json['brokerName'],
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
    };
}

export function AdminRiskSummaryDtoToJSON(json: any): AdminRiskSummaryDto {
    return AdminRiskSummaryDtoToJSONTyped(json, false);
}

export function AdminRiskSummaryDtoToJSONTyped(value?: AdminRiskSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'statusLabel': value['statusLabel'],
        'simulationIdentifier': IdLabelToJSON(value['simulationIdentifier']),
        'contractIdentifier': IdLabelToJSON(value['contractIdentifier']),
        'quoteIdentifiers': value['quoteIdentifiers'] == null ? undefined : ((value['quoteIdentifiers'] as Array<any>).map(IdLabelToJSON)),
        'insureds': value['insureds'] == null ? undefined : ((value['insureds'] as Array<any>).map(IdLabelToJSON)),
        'branchCode': value['branchCode'],
        'products': value['products'],
        'sourceId': value['sourceId'],
        'sourceCode': value['sourceCode'],
        'sourceLabel': value['sourceLabel'],
        'unreadNotificationCount': value['unreadNotificationCount'],
        'borrowerProjectId': value['borrowerProjectId'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
        'plateformeId': value['plateformeId'],
        'plateformeName': value['plateformeName'],
    };
}

